export default "__VITE_ASSET__DYBug7hU__"